/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Zubair Wani",
  title: "Hi all, I'm Zubair",
  subTitle: emoji(
    "A Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Python / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/15oFMf8OCV8lWW0fpdGk7XEA53Se-N9wp/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/zubairwani",
  linkedin: "https://www.linkedin.com/in/zubairwani/",
  gmail: "zubairwani49@gmail.com",
  gitlab: "https://gitlab.com/zubairwani",
  // facebook: "https://www.facebook.com/",
  // medium: "https://medium.com/@",
  // stackoverflow: "https://stackoverflow.com/users/10422806/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end & Backend for your web and mobile applications"
    ),
    emoji(
      "⚡ Skilled in creating robust web apps using JavaScript, TypeScript, Python, React, and other modern technologies"
    ),
    emoji(
      "⚡ Integration of third-party services such as Firebase, AWS, and Azure"
    )
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "MongoDb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section


const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Kashmir",
      logo: require("./assets/images/universitylogo.jpg"),
      subHeader: "Master of Computer Applications",
      duration: "August 2022 - February 2025",
      desc: "Skills: Data Structures using C++ · Computer Networks · Programming with C++ · Artificial Intelligence (AI) · Computer Graphics · Machine Learning · Assembly Language Programming · Python · JavaScript · Design and Analysis of Algorithms ",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "University of Kashmir",
      logo: require("./assets/images/universitylogo.jpg"),
      subHeader: "Bachelor of Computer Applications",
      duration: "September 2018 - April 2022",
      desc: "Skills: Computer Networks · Data Structures · C++ · Artificial Neural Networks · Front-End Development · Java",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
      {
      role: "Software Developer",
      company: "Moong Labs Technologies",
      companylogo: require("./assets/images/moongLogo.png"),
      date: "Nov 2025 – Apr 2026",
      desc: "Moong Labs is an indian gaming studio based in Noida, founded in 2013, developing and publishing free-to-play simulation games. The company builds console-quality gaming experiences for mobile and also targets major mobile platforms along with Xbox."
    },
    {
      role: "FullStack Developer",
      company: "DevMatrix IT Solutions",
      companylogo: require("./assets/images/FavDark.png"),
      date: "Nov 2024 - Oct 2025",
      desc: "DevMatrix IT Solutions is a forward-thinking technology company committed to delivering innovative and efficient IT solutions.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      // ]
    },
    {
      role: "Frontend Developer",
      company: "Navrekh Technologies Pvt Ltd",
      companylogo: require("./assets/images/NavrekhLogo.jpg"),
      date: "May 2024 – Oct 2024",
      desc: "YourSportz is a comprehensive sports platform tailored for football enthusiasts. Whether you're a player, coach, or fan, this app caters to your needs.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND BUSSINESSES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
     {
      image: require("./assets/images/tabeeb.jpg"),
      projectName: "Tabeeb Medical Solutions",
      projectDesc: "Connect with healthcare professionals online, book lab tests, and access quality medical services from the comfort of your home.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://tabeeb.co.in/"
        }
      ]
    },
      {
      image: require("./assets/images/onecallkashmir.png"),
      projectName: "One Call Kashmir",
      projectDesc: "Discover the beauty of Kashmir with expertly curated tours, serene Shikara rides, seamless transport, luxurious accommodations, and thrilling adventure experiences.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://onecallkashmir.netlify.app/"
        }
      ]
    },
    // {
    //   image: require("./assets/images/FavDark.png"),
    //   projectName: "DevMatrix IT Solutions",
    //   projectDesc: "DevMatrix IT Solutions is a forward-thinking technology company committed to delivering innovative and efficient IT solutions.",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://devmatrix.org/"
    //     }
    //     //  you can add extra buttons here.
    //   ] 
    // },
    // {
    //   image: require("./assets/images/YoursportzLogoWhite.jpg"),
    //   projectName: "YourSportz",
    //   projectDesc: "YourSportz is a comprehensive sports platform tailored for football enthusiasts. Whether you're a player, coach, or fan, this app caters to your needs.",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://yoursportz.in/"
    //     }
    //     //  you can add extra buttons here.
    //   ]
    // },
    {
      image: require("./assets/images/HomeBasicsLogo.png"),
      projectName: "Home Basics",
      projectDesc: "Home Basics: Delivering excellence in water purification and expert water heater installation and repair services you can trust.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://homebasics.onrender.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    // {
    //   image: require("./assets/images/NavrekhLogo.jpg"),
    //   projectName: "Navrekh Tech",
    //   projectDesc: "Empowering communities with innovative platforms for sports, communication, and social media.",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://navrekhtech.com"
    //     }
    //   ]
    // },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google IT Automation with Python – Coursera | Google",
      subtitle:
        "Completed all 6 professional certifications covering Python, Git, automation, and troubleshooting.",
      image: require("./assets/images/google.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://coursera.org/share/64fec3b6e06c3b6204780265f4ee8fe0"
        },
      ]
    },
     {
      title: "AWS Cloud Practitioner Essentials",
      subtitle:
        " Learned core AWS services including compute, storage, networking, databases, security, monitoring, Auto Scaling, and cloud architecture fundamentals.",
      image: require("./assets/images/aws.jpg"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/in/zubairwani/details/certifications/"
        },
      ]
    },
    // {
    //   title: "Using Python to Interact with Operating System",
    //   subtitle:
    //     "File Sytem · Scripting · CLI · Shell Scripting · Bash · Unix Commands · Linux Commands · Automation",
    //   image: require("./assets/images/google.png"),
    //   imageAlt: "Google Code-In Logo",
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://www.coursera.org/account/accomplishments/verify/Q4CZAGKCVWKJ"
    //     },
    //   ]
    // },
    {
      title: "Google Cloud IAM and Networking for AWS Professionals",
      subtitle:
        "Load Balancing, Google, Google Cloud Platform, Cloud Computing",
      image: require("./assets/images/googleCloud.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/verify/G42GF645757V"
        }
      ]
    },

    {
      title: "Git and Github",
      subtitle: "Google Career Certificates: Interacting with GitHub, Reverting Changes, Version Control Systems, Creating Pull Requests, Using Git",
      image: require("./assets/images/google.png"),
      imageAlt: "Google Logo",
      footerLink: [
        { name: "Certification", url: "https://www.coursera.org/account/accomplishments/verify/WPOMARBI9KIF" },
        // {
        //   name: "Final Project",
        //   url: ""
        // }
      ]
    },

    {
      title: "Configuration Management and the Cloud",
      subtitle: "Configuration Management, Automation at Scale, Cloud Computing, Basic Monitoring & Alerting, Using Puppet",
      image: require("./assets/images/googleCloud.png"),
      imageAlt: "Google Logo",
      footerLink: [
        { name: "Certification", url: "https://www.coursera.org/account/accomplishments/verify/I7HXBKJMHLUU" },
        // {
        //   name: "Final Project",
        //   url: ""
        // }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://yoursportz.in/blog/66755044d307829c7dae674e-1719999050754",
      title: "YourSportz",
      description:
        "YourSportz is a comprehensive sports platform tailored for football enthusiasts. Whether you're a player, coach, or fan, this app caters to your needs."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I love to listen to discussions about technology and innovation.",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9149923238",
  email_address: "Zubairwani49@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "_zubairwani_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
